import script from "./realtime-attribute.vue?vue&type=script&setup=true&lang=ts"
export * from "./realtime-attribute.vue?vue&type=script&setup=true&lang=ts"

import "./realtime-attribute.vue?vue&type=style&index=0&id=181b0ca3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-181b0ca3"]])

export default __exports__